

import React, { useState, useCallback } from 'react'
import styled from 'styled-components'

import { ButtonYellowLight } from '../../Button'
import Loader from '../../Loader'
import { AutoRow } from '../../Row'

import { stopPropagation } from '../../../utils/func'
import { useActiveWeb3React } from '../../../hooks'
import { userMarketType } from '../../../userType/userMarketType'
import useOpenBlindBox from '../../../hooks/nft/useOpenBlindBox'

const Button = styled(ButtonYellowLight)`
  border: 1px solid #E0DAD3;
  background-color: initial;
  color: ${({ theme }) => theme.bsText32};
  font-family: 'Roboto-Regular';
  height: 32px;
  margin-top: 19px;
  padding: 0;
  font-size: 14px;
`

export default function OpenBtn({artwork}: {artwork: any}) {
  const { account } = useActiveWeb3React()
  const markeyType = userMarketType(artwork.nftType, artwork.nftLevel)
  // 开盲盒
  const { onOpenBlindBox } = useOpenBlindBox(artwork.tokenId, markeyType)
  const [requestedOpen, setRequestedOpen] = useState(false)
  const handleOpen = useCallback(async (event) => {
      event.preventDefault()
      try {
          stopPropagation(event)
          setRequestedOpen(true)
          const txHash = await onOpenBlindBox()
          if (!txHash) {
              setRequestedOpen(false)
          } else {
              setTimeout(() => {
                  setRequestedOpen(false)
              }, 10000)
          }
      } catch (e) {
          console.log(e)
      }
  }, [onOpenBlindBox, account])
  
  return(
    <Button
      onClick={handleOpen}
      disabled={requestedOpen}
      fontSize={14}
      height={40}
      altDisabledStyle={requestedOpen} // show solid button while waiting
      style={{
          padding: '0',
          width: '100%'
      }}
    >
      {
        requestedOpen ? 
          <AutoRow gap="6px" justify="center">
              Opening <Loader stroke="white" />
          </AutoRow>
        : 'Open'
      }
    </Button>
  )
}